import React, { useContext, useState , useEffect } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Context from '../../context/context';

function CurrencyType() {
    const {state, dispatch} = useContext(Context);
    const [currency, setCurrency] = useState(1);
    const setCurrencyDispatch = data => dispatch({type:"SET_CURRENCY", payload: data});
    const setPrice = data => dispatch({type:"SET_PRICE_PERCENT", payload: data});
    const setPriceBack = data => dispatch({type:"SET_PRICE_BACK_PERCENT", payload: data});

    useEffect(() =>{
        setCurrencyDispatch(1)
   }, [])

    const handleChangeCurrency = (event) => {
        const currencyType = event.target.value;
        setCurrency(currencyType)
        setCurrencyDispatch(currencyType)
      };

  return (
    <div>
        <p style={{ fontWeight: 'bold', textAlign:'center'}}>בחר סוג מטבע</p>
         <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={currency}
            onChange={handleChangeCurrency}
            label=" מטבע"
            autoWidth
            className='dateInput'
            style={{ width : '300px'}}
            >
            <MenuItem value={1}>₪</MenuItem>
            <MenuItem value={2}>$</MenuItem>
         </Select>
    </div>
  )
}

export default CurrencyType